import * as Api from "@api";
import * as C from "@components";
import { Column, Container, Margin, PageContent, PageLink, PageLinkVariant, PageSection, Typography } from "@components";
import React from "react";
import { ConsistentVaporizationCard, ConsistentVaporizationCardContentKeys } from "../ConsistentVaporizationCard/ConsistentVaporizationCard";
import { HeatingConsistencyCard, HeatingConsistencyCardContentKeys } from "../HeatingCosistency/HeatingConsistencyCard";
import { SmoothEvenHeatingCard, SmoothEvenHeatingCardContentKeys } from "../SmoothEvenHeatingCard/SmoothEvenHeatingCard";

export const ProductXLDesignSectionKeys = [
    "design.headline",
    "design.body",
    "design.link",
    ...HeatingConsistencyCardContentKeys,
    ...ConsistentVaporizationCardContentKeys,
    ...SmoothEvenHeatingCardContentKeys,
] as const;

type ProductXLDesignSectionContent = Api.Content<typeof ProductXLDesignSectionKeys[number]>;

interface ProductXLDesignSectionProps
{
    pageContent: ProductXLDesignSectionContent;
}

export const ProductXLDesignSection = ({ pageContent }: ProductXLDesignSectionProps): React.FunctionComponentElement<ProductXLDesignSectionProps> =>
    <PageSection>
        <C.Column 
            margins={{
                mobile: { bottom: C.Margin.D24 },
                ipad: { bottom: C.Margin.D108 },
                desktop: { bottom: C.Margin.D108 }
            }}
        >
            <PageContent {...pageContent["design.headline"]} centered margins={{ bottom: Margin.D24 }} typography={Typography.H2} />
            <PageContent {...pageContent["design.body"]} centered margins={{ bottom: Margin.D24 }} typography={Typography.P2} />
            <PageLink href="/no-burn-vapor-technology" variant={PageLinkVariant.Link}>
                {pageContent["design.link"].data}
            </PageLink>
        </C.Column>
        <Container verticalGap={24} horizontalGap={24}>
            <HeatingConsistencyCard pageContent={pageContent} />
            <ConsistentVaporizationCard pageContent={pageContent} />
            <SmoothEvenHeatingCard pageContent={pageContent} />
        </Container>
    </PageSection>
    ;